<template>
    <SOSlotModal  
        modal-title="Pilih transaksi"
        :modal-id="id"
        :no-padding="true"
        @close="close()"
        stack-modal
        force-bg
    >
        <template v-slot:modal-body>
            <div class="bg-gray">
                <div>
                    <div class="bg-white px-4 mt-2" v-if="searchData">
                        <SOInputSearch
                            :id="'cari-transaksi'"
                            :placeholder="'Ketik Nama / ID Transaksi / No. Telp'"
                            autocomplete="off"
                            :do-searching="searchTransaksi"
                            :delay-time="500"
                        />
                        <div
                            class="d-flex py-2"
                            :class="{ 'visible': isLoading}"
                            style="gap: 3px; visibility: hidden"
                        >
                            <span class="spinner-border spinner-border-sm f-c-midgrey " role="status" aria-hidden="true"></span>
                            <span class="f-14 f-c-midgrey">
                                Memuat data...
                            </span>
                        </div>
                    </div>
                    <div v-if="searchData" class="f-c-midgrey px-4 my-3">
                        <span>{{ countData }} Transaksi</span>
                    </div>
                    <div class="bg-white m-d-12 px-4 py-2" v-else>
                        <p class="f-14 f-c-midgrey m-d-0">Ditemukan <span class="f-semi">{{ listTransaksi.length }} transaksi</span> yang mungkin terkait dengan komplain ini. Pilih salah satu transaksi yang sesuai.</p>
                    </div>
                    <div class="max-height-50 over-y-auto px-4 py-2">
                        <CardTransaksi
                            v-for="(item, index) in listData"
                            :key="index"
                            :data="item"
                            @click.native="selectItem(item.id)"
                        />
                        <div v-if="listData.length < countData && searchData">
                            <SOLoadMoreLoading
                                :id="'load-more-list-snapTransaksi'"
                                loading
                                @intersect="!isLoadingMore && loadMore()"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:modal-footer>
            <div class="px-4" v-if="!searchData">
                <div class="m-d-12 m-t-12">
                    <label class="m-d-0 d-flex" @click="toggleCheck">
                        <SOCheckBox :is-checked="confirmSearch" />
                        <span class="f-14 m-l-12">Saya tidak menemukan transaksi yang saya cari</span>
                    </label>
                </div>
                <div v-if="confirmSearch">
                    <SOButton
                        :primary="true"
                        :full="true"
                        :text="'Cari Lebih Lanjut'"
                        :id="`search-more-transaction`"
                        @action="confirmed()"
                    />
                </div>
            </div>
        </template>
    </SOSlotModal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { moduleName } from "../store/state";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";
import CardTransaksi from "./CardTransaksi";
import SOCheckBox from "@/so-components/global/ui/SOCheckBox";
import SOInputSearch from "@/so-components/global/input/SOInputSearch";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";

export default {
    name: "modalListTransaksi",
    components: {
        SOSlotModal,
        SOButton,
        CardTransaksi,
        SOInputSearch,
        SOCheckBox,
        SOLoadMoreLoading
    },
    data () {
        return {
            id:"modal-transaksi",
            searchResult: [],
            isLoading: false,
            isLoadingMore: false,
            confirmSearch: false,
            searchData: false,
            listSnap: [],
            payload: {},
        }
    },
    computed: {
        ...mapGetters(moduleName, {
            listTransaksi: "listTransaksi",
            countData: "countData",
        }),
        listData() {
            return this.searchData ? this.searchResult : this.listTransaksi
        },
        idKomplain() {
            return this.$store.state.komplainQrisModule.idKomplain
        }
    },
    methods: {
        ...mapActions({
            searchSnapTransaksi: `${moduleName}/searchSnapTransaksi`,
        }),
        defaultPayload() {
            return {
                id: this.idKomplain,
                search: "",
                limit: 20,
                offset: 0,
            }
        },
        open() {
            $("#" + this.id).modal("show");
            this.searchResult = []
            this.confirmSearch = false
            this.searchData = false
        },
        close() {
            $("#" + this.id).modal("hide");
            setTimeout(() => {
                $("body").addClass("modal-open")
                this.$emit("close");
            }, 500);
        },
        async searchTransaksi(v) {
            this.isLoading = true
            try {
                this.payload.search = v
                this.payload.offset = 0
                const res = await this.searchSnapTransaksi(this.payload)
                if (res.data.length) {
                    this.searchResult = res.data
                }
                else {
                    this.$toast.warning('Data tidak ditemukan')
                }
                this.isLoading = false
            } catch (error) {
                this.$toast.error(error)
                this.isLoading = false
            }
        },
        selectItem(id) {
            this.$emit('selected', id)
            this.close()
        },
        toggleCheck() {
            this.confirmSearch = !this.confirmSearch;
        },
        confirmed() {
            this.payload = this.defaultPayload();
            this.searchData = true;
            this.searchTransaksi("");
        },
        async loadMore() {
            this.isLoadingMore = true
            this.payload.offset = this.listData.length
            try {
                const res = await this.searchSnapTransaksi(this.payload)
                this.searchResult.push(...res.data)

            } catch (error) {
                this.$toast.error(error)
            }
            this.isLoadingMore = false
        },
    },
}
</script>